export function setNotifications(data) {
    return {
        type: 'SET_NOTIFICATIONS',
        data: data
    };
}

export function addNotification(data) {
    return {
        type: 'ADD_NOTIFICATION',
        data: data
    };
}

export function getNotificationList(data) {
    return {
        type: 'GET_NOTIFICATION_LIST',
        data: data
    }
}

export function doneGetNotificationList(data) {
    return {
        type: 'DONE_GET_NOTIFICATION_LIST',
        data
    }
}

export function errorGetNotificationList(data) {
    return {
        type: 'ERROR_GET_NOTIFICATION_LIST',
        data
    }
}

export function markNotificationRead(id) {
    return {
        type: 'MARK_NOTIFICATION_READ',
        id
    };
}

export function clearNotification(id) {
    return {
        type: 'CLEAR_NOTIFICATION',
        id
    };
}

export function clearAllNotifications() {
    return {
        type: 'CLEAR_ALL_NOTIFICATIONS'
    };
}

export function notificationsConnecting() {
    return {
        type: 'NOTIFICATIONS_CONNECTING'
    };
}

export function notificationsConnected() {
    return {
        type: 'NOTIFICATIONS_CONNECTED'
    };
}

// Dispatched once at app boot (src/app.jsx) whenever a valid session already exists -
// on a plain page refresh, PrivateRoute (src/routes.jsx) renders straight to the
// authenticated UI without dispatching DONE_LOGIN or any other action, so
// notificationSyncSaga.jsx's fetchNotificationsCall needs a second trigger that fires
// on that path too, not just on a fresh login.
export function fetchNotifications() {
    return {
        type: 'FETCH_NOTIFICATIONS'
    };
}

// Dispatched by the bell dropdown's scroll-near-bottom / big-monitor-backfill
// triggers (notifications-menu/index.jsx) to fetch the next older page of history.
// Flag-off users never dispatch this (their whole list already loads in one shot).
export function fetchMoreNotifications() {
    return {
        type: 'FETCH_MORE_NOTIFICATIONS'
    };
}

// Dispatched by notificationSyncSaga.jsx's fetchMoreNotificationsCall on a successful
// "load more" fetch. `data.list` is prepended (older items) to the front of the
// existing list by the reducer; `data.nextCursor` replaces the stored cursor.
export function appendOlderNotifications(data) {
    return {
        type: 'APPEND_OLDER_NOTIFICATIONS',
        data
    };
}

// Dispatched on a failed "load more" fetch so the reducer can clear isLoadingMore -
// otherwise the bottom-of-list spinner would spin forever after a network error.
export function notificationsLoadMoreFailed() {
    return {
        type: 'NOTIFICATIONS_LOAD_MORE_FAILED'
    };
}
